import BaseActions from './../../base/actions'
import Schema from './schema'

export default BaseActions({module: 'employeeResponsibilities'}, {
  //
}, [Schema])
